(() => {
  if (window.__CART_GIFTS_INIT__) return
  window.__CART_GIFTS_INIT__ = true

  const GIFT_SYNC_HEADER = 'X-Gift-Sync'

  function isWholesaleCustomerInDrawerDOM() {
    const drawer = document.querySelector('#CartDrawer')
    return drawer?.dataset?.isWholesaleCustomer === 'true'
  }

  // Gift variants
  const GIFT_75 = '42618513326273' // Rug Gripper
  const GIFT_125 = '49465770737857' // Muddy Mitt
  const giftVariantIds = new Set([String(GIFT_75), String(GIFT_125)])

  // Gift images (for optimistic placeholders only)
  const GIFT_75_IMG = 'https://muddymats.com/cdn/shop/files/free-120-img.jpg?v=1758057053&width=300'
  const GIFT_125_IMG =
    'https://muddymats.com/cdn/shop/files/muddymitt_04dd775f-712c-46a7-8f45-8e84fcac53e7.png?v=1754568555&width=300'

  const GIFT_75_TITLE = 'Muddy Mat - Rug Gripper (Free Gift)'
  const GIFT_125_TITLE = 'Muddy Mitt'

  const origFetch = window.fetch.bind(window)

  let inGiftSync = false
  let giftSyncTimer = null
  let pendingCart = null
  let syncQueued = false

  function isCartMutationUrl(url = '') {
    return url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')
  }

  function findCartListContainer() {
    return document.querySelector('cart-drawer-items tbody') || document.querySelector('cart-items tbody')
  }

  function getSubtotalCentsFromDOM() {
    const el = document.querySelector('[data-hulkapps-cart-total]')
    if (!el) return 0

    const cents = parseInt(el.dataset.subtotalCents || '0', 10)
    if (Number.isFinite(cents) && cents >= 0) return cents

    const txt = (el.textContent || '').replace(/[^\d.,]/g, '').replace(',', '.')
    const n = parseFloat(txt || '0')
    return Number.isFinite(n) ? Math.round(n * 100) : 0
  }

  function predictSubtotalCentsFromAction(btnEl) {
    const current = getSubtotalCentsFromDOM()
    const row = btnEl?.closest?.('tr.cart-item')
    if (!row) return current

    const unit = parseInt(row.dataset.unitPriceCents || '0', 10) || 0
    const lineTotal = parseInt(row.dataset.lineTotalCents || '0', 10) || 0

    const qtyInput = row.querySelector('input.quantity__input')
    const qty = parseInt(qtyInput?.value || '0', 10) || 0

    const isRemove =
      btnEl.closest('cart-remove-button') ||
      btnEl.classList?.contains('cart-remove') ||
      btnEl.hasAttribute?.('data-cart-remove')

    if (isRemove) return Math.max(0, current - lineTotal)

    const name = btnEl.getAttribute?.('name')
    if (name === 'minus') {
      if (qty <= 1) return Math.max(0, current - lineTotal)
      return Math.max(0, current - unit)
    }

    if (name === 'plus') return Math.max(0, current + unit)
    return current
  }

  // -------------------------------
  // Optimistic gift placeholders (visual only)
  // -------------------------------
  function findRealGiftRow(variantId) {
    const input = document.querySelector(`input[data-quantity-variant-id="${variantId}"]`)
    const row = input?.closest('tr.cart-item') || null
    if (row && row.getAttribute('data-mm-gift-ui') === '1') return null
    return row
  }

  function findOptimisticGiftRow(variantId) {
    return document.querySelector(`tr[data-mm-gift-ui="1"][data-variant-id="${variantId}"]`)
  }

  function cleanupOptimisticGiftPlaceholders() {
    document.querySelectorAll('tr[data-mm-gift-ui="1"]').forEach((el) => el.remove())
  }

  function buildOptimisticGiftRow(variantId) {
    const tr = document.createElement('tr')

    tr.className = 'cart-item'
    tr.setAttribute('data-mm-gift-ui', '1')
    tr.setAttribute('data-variant-id', String(variantId))
    tr.setAttribute('data-is-gift', 'true')
    tr.dataset.unitPriceCents = '0'
    tr.dataset.lineTotalCents = '0'

    const img = String(variantId) === String(GIFT_75) ? GIFT_75_IMG : GIFT_125_IMG
    const title = String(variantId) === String(GIFT_75) ? GIFT_75_TITLE : GIFT_125_TITLE

    tr.innerHTML = `
      <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
        <a href="javascript:void(0);" class="cart-item__link" tabindex="-1" aria-hidden="true" style="cursor:default;"> </a>
        <img class="cart-item__image" src="${img}" alt="${title}" loading="eager" width="150">
      </td>

      <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">
        <a href="javascript:void(0);" class="cart-item__name h4 break" style="cursor:default;">
          ${title}
        </a>
      </td>

      <td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">
        <quantity-popover>
          <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
            <div class="quantity-popover-container">
              <quantity-input class="quantity cart-quantity">
                <button class="quantity__button" name="minus" type="button" style="display:none;"></button>
                <input class="quantity__input" type="number" value="1" min="0" step="1" readonly aria-hidden="true" tabindex="-1">
                <button class="quantity__button" name="plus" type="button" style="display:none;"></button>
              </quantity-input>
            </div>

            <cart-remove-button style="display:none;">
              <button type="button" class="button button--tertiary cart-remove-button"></button>
            </cart-remove-button>
          </div>
        </quantity-popover>
      </td>

      <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">
        <div class="cart-item__price-wrapper">
          <span class="price price--end">FREE</span>
        </div>
      </td>
    `

    return tr
  }

  function optimisticEnsureGift(variantId) {
    const container = findCartListContainer()
    if (!container) return

    if (findRealGiftRow(variantId)) {
      optimisticRemoveGift(variantId)
      return
    }

    if (findOptimisticGiftRow(variantId)) return

    const row = buildOptimisticGiftRow(variantId)
    const anchor = container.querySelector('tr.cart-item')
    if (anchor) container.insertBefore(row, anchor)
    else container.appendChild(row)
  }

  function optimisticRemoveGift(variantId) {
    const row = findOptimisticGiftRow(variantId)
    if (row) row.remove()
  }

  function setRowHidden(row, hidden) {
    if (!row) return
    row.style.display = hidden ? 'none' : ''
  }

  // -------------------------------
  // Gift visibility lock (anti-flicker)
  // -------------------------------
  function setGiftVisibilityLock({ want75, want125, ttl = 2500 }) {
    window.__MM_GIFT_VIS_LOCK__ = {
      want75: !!want75,
      want125: !!want125,
      until: Date.now() + ttl,
    }
  }

  function applyGiftVisibilityLock() {
    const lock = window.__MM_GIFT_VIS_LOCK__
    if (!lock) return
    if (Date.now() > lock.until) return

    setRowHidden(findRealGiftRow(GIFT_75), !lock.want75)
    setRowHidden(findRealGiftRow(GIFT_125), !lock.want125)
  }

  function applyOptimisticRowsFromLock() {
    const lock = window.__MM_GIFT_VIS_LOCK__
    if (!lock) return

    if (lock.want75) {
      setRowHidden(findRealGiftRow(GIFT_75), false)
      optimisticEnsureGift(GIFT_75)
    } else {
      optimisticRemoveGift(GIFT_75)
      setRowHidden(findRealGiftRow(GIFT_75), true)
    }

    if (lock.want125) {
      setRowHidden(findRealGiftRow(GIFT_125), false)
      optimisticEnsureGift(GIFT_125)
    } else {
      optimisticRemoveGift(GIFT_125)
      setRowHidden(findRealGiftRow(GIFT_125), true)
    }
  }

  function optimisticApply(forcedSubtotalCents) {
    if (isWholesaleCustomerInDrawerDOM()) {
      optimisticRemoveGift(GIFT_75)
      optimisticRemoveGift(GIFT_125)
      setRowHidden(findRealGiftRow(GIFT_75), true)
      setRowHidden(findRealGiftRow(GIFT_125), true)
      return
    }

    const subtotalCents = typeof forcedSubtotalCents === 'number' ? forcedSubtotalCents : getSubtotalCentsFromDOM()
    const want75 = subtotalCents >= 7500
    const want125 = subtotalCents >= 12500

    setGiftVisibilityLock({ want75, want125, ttl: 2500 })
    applyGiftVisibilityLock()
    applyOptimisticRowsFromLock()
  }

  function attachSubtotalObserver() {
    const target = document.querySelector('[data-hulkapps-cart-total]')
    if (!target) return

    const obs = new MutationObserver(() => {
      applyGiftVisibilityLock()
      applyOptimisticRowsFromLock()
    })

    obs.observe(target, { childList: true, subtree: true, characterData: true })
  }

  // -------------------------------
  // Server sync
  // -------------------------------
  async function fetchCart() {
    const res = await origFetch('/cart.js', { cache: 'no-store' })
    return res.json()
  }

  function calcPaidTotal(cart) {
    const paidTotalCents = (cart.items || []).reduce((sum, item) => {
      if (giftVariantIds.has(String(item.variant_id))) return sum
      return sum + (item.final_line_price || 0)
    }, 0)
    return paidTotalCents
  }

  function findGift(cart, variantId) {
    return (cart.items || []).find((i) => String(i.variant_id) === String(variantId))
  }

  async function fetchSectionsFallback() {
    const sRes = await origFetch('/?sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
    return sRes.json()
  }

  async function ensureSections(data) {
    if (data?.sections) return data
    try {
      const sections = await fetchSectionsFallback()
      return {
        ...data,
        sections: {
          'cart-drawer': sections['cart-drawer'],
          'cart-icon-bubble': sections['cart-icon-bubble'],
        },
      }
    } catch {
      return data
    }
  }

  async function renderDrawerIfOpen(data) {
    const drawer = document.querySelector('cart-drawer')
    if (!drawer || typeof drawer.renderContents !== 'function') return
    const payload = await ensureSections(data)
    drawer.renderContents(payload)
    cleanupOptimisticGiftPlaceholders()
    applyGiftVisibilityLock()
    applyOptimisticRowsFromLock()
  }

  async function cartUpdate(updates) {
    const res = await origFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        [GIFT_SYNC_HEADER]: '1',
      },
      cache: 'no-store',
      body: JSON.stringify({
        updates,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })

    const data = await res.json()
    if (!res.ok) return null
    return data
  }

  async function cartAddMany(variantIds) {
    const items = variantIds.map((id) => ({ id, quantity: 1 }))

    const res = await origFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        [GIFT_SYNC_HEADER]: '1',
      },
      cache: 'no-store',
      body: JSON.stringify({
        items,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })

    const data = await res.json()
    if (!res.ok) return null
    return data
  }

  async function cartAdd(variantId) {
    const res = await origFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        [GIFT_SYNC_HEADER]: '1',
      },
      cache: 'no-store',
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })

    const data = await res.json()
    if (!res.ok) return null
    return data
  }

  async function syncGiftsFromCart(cartInput) {
    if (isWholesaleCustomerInDrawerDOM()) {
      const cart = cartInput?.items ? cartInput : await fetchCart()

      const updates = {}
      const gift75 = findGift(cart, GIFT_75)
      const gift125 = findGift(cart, GIFT_125)

      if (gift75) updates[String(GIFT_75)] = 0
      if (gift125) updates[String(GIFT_125)] = 0

      if (Object.keys(updates).length) {
        const data = await cartUpdate(updates)
        return { changed: true, data }
      }

      return { changed: false, data: null }
    }

    const cart = cartInput?.items ? cartInput : await fetchCart()

    const paidTotalCents = calcPaidTotal(cart)

    const want75 = paidTotalCents >= 7500 ? 1 : 0
    const want125 = paidTotalCents >= 12500 ? 1 : 0

    setGiftVisibilityLock({ want75: want75 === 1, want125: want125 === 1, ttl: 2500 })

    const gift75 = findGift(cart, GIFT_75)
    const gift125 = findGift(cart, GIFT_125)

    const updates = {}
    const needAdd = []

    if (gift75) {
      if (gift75.quantity !== want75) updates[String(GIFT_75)] = want75
    } else if (want75 === 1) {
      needAdd.push(GIFT_75)
    }

    if (gift125) {
      if (gift125.quantity !== want125) updates[String(GIFT_125)] = want125
    } else if (want125 === 1) {
      needAdd.push(GIFT_125)
    }

    if (!Object.keys(updates).length && needAdd.length === 0) {
      return { changed: false, data: null }
    }

    let data = null

    if (Object.keys(updates).length) {
      data = await cartUpdate(updates)
      if (!data) return { changed: false, data: null }
    }

    if (needAdd.length > 0) {
      const filtered = needAdd.filter((variantId) => !findGift(cart, variantId))

      let addedData = null
      if (filtered.length > 0) {
        addedData = await cartAddMany(filtered)

        if (!addedData) {
          for (const id of filtered) {
            const one = await cartAdd(id)
            if (one) addedData = one
          }
        }

        if (addedData) data = addedData
      }
    }

    if (needAdd.length > 0) {
      const freshCart = await fetchCart()
      const g75 = findGift(freshCart, GIFT_75)
      const g125 = findGift(freshCart, GIFT_125)

      const enforce = {}
      if (g75 && g75.quantity > 1) enforce[String(GIFT_75)] = 1
      if (g125 && g125.quantity > 1) enforce[String(GIFT_125)] = 1

      if (Object.keys(enforce).length) {
        const fixed = await cartUpdate(enforce)
        if (fixed) data = fixed
      }
    }

    return { changed: true, data }
  }

  function scheduleGiftSync() {
    if (giftSyncTimer) clearTimeout(giftSyncTimer)

    giftSyncTimer = setTimeout(async () => {
      giftSyncTimer = null

      if (inGiftSync) {
        syncQueued = true
        return
      }

      inGiftSync = true

      try {
        const cart = pendingCart?.items ? pendingCart : await fetchCart()
        const result = await syncGiftsFromCart(cart)
        if (result?.changed && result.data) {
          await renderDrawerIfOpen(result.data)
        }
      } finally {
        inGiftSync = false
        pendingCart = null

        if (syncQueued) {
          syncQueued = false
          scheduleGiftSync()
        }
      }
    }, 40)
  }

  // -------------------------------
  // Fetch hook
  // -------------------------------
  window.fetch = async (...args) => {
    const opts = args[1] || {}
    const hdrs = opts.headers

    const isGiftSyncRequest =
      (hdrs instanceof Headers && hdrs.get(GIFT_SYNC_HEADER) === '1') ||
      (hdrs &&
        !(hdrs instanceof Headers) &&
        (hdrs[GIFT_SYNC_HEADER] === '1' || hdrs[GIFT_SYNC_HEADER.toLowerCase()] === '1'))

    const res = await origFetch(...args)

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || ''
      if (!isCartMutationUrl(url)) return res

      if (isGiftSyncRequest || inGiftSync) return res

      try {
        const json = await res.clone().json()
        if (json && json.items) pendingCart = json
      } catch (_) {}

      optimisticApply()
      scheduleGiftSync()
    } catch (_) {}

    return res
  }

  // Apply optimistic gift visibility immediately on UI interactions
  document.addEventListener(
    'click',
    (e) => {
      const btn =
        e.target.closest('.quantity__button') ||
        e.target.closest('cart-remove-button, .cart-remove, [data-cart-remove]')
      if (!btn) return
      const predicted = predictSubtotalCentsFromAction(btn)
      optimisticApply(predicted)
    },
    true
  )

  // Upsell "Add" button inside drawer
  document.addEventListener(
    'pointerup',
    async (e) => {
      const btn = e.target.closest('.cart_upsell_item_actions .add_btn')
      if (!btn) return
      if (btn.dataset.dragging === '1') return

      e.preventDefault()
      e.stopPropagation()

      const variantId = btn.dataset.variantId || btn.dataset.variant_id
      if (!variantId) return

      btn.disabled = true

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          cache: 'no-store',
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })

        const data = await res.json()
        if (!res.ok) return

        // Render immediately (then gift sync hook will run automatically)
        await renderDrawerIfOpen(data)
      } catch (_) {
      } finally {
        btn.disabled = false
      }
    },
    true
  )

  window.cartGiftsSync = async () => {
    const cart = await fetchCart()
    const result = await syncGiftsFromCart(cart)
    if (result?.changed && result.data) await renderDrawerIfOpen(result.data)
    return result
  }

  document.addEventListener('DOMContentLoaded', () => {
    attachSubtotalObserver()
    optimisticApply()
  })

  window.MMCartGifts = window.MMCartGifts || {}
  window.MMCartGifts.optimisticApply = optimisticApply
  window.MMCartGifts.applyGiftVisibilityLock = applyGiftVisibilityLock
})()